<template>
  <div class="coupon-box">

    <!-- <ul>
      <li @click="receive">
        <div class="box coupon-div">
          <p class="discount">￥{{coupinItem.discount}}</p>
          <p class="min">满{{coupinItem.min}}元可用</p>
        </div>
        <div class="box">
          <div class="coupon-name">{{coupinItem.name}}</div>
          <div class="coupon-time">有效期至: {{coupinItem.days}}天</div>
          <div v-if="coupinItem.my" class="coupon-time hasHav">已领取</div>
        </div>

      </li>
    </ul> -->
    <div :class="uiCoupinItem.isFill == 1 ? 'left-content-eee':'left-content'">
      <div class="discount">
        <span class="rmb-icon">￥</span> <span v-if="uiCoupinItem.discount">{{uiCoupinItem.discount}}</span> <span v-else>{{uiCoupinItem.valueDesc}}</span>
      </div>
      <div class="content">
        <div class="coupon-name">{{uiCoupinItem.name}}</div>
        <div class="min" v-if="uiCoupinItem.min">满{{uiCoupinItem.min}}元可用</div>
        <div class="min" v-else>{{uiCoupinItem.condition}}</div>
        <div class="coupon-time" v-if="uiCoupinItem.endTime != undefined">有效期: {{uiCoupinItem.startTime.substr(0,10)}} ~ {{uiCoupinItem.endTime.substr(0,10)}}</div>
        <div class="coupon-time" v-if="uiCoupinItem.available != undefined && uiCoupinItem.available!=0">有效期: {{uiCoupinItem.available}}天</div>
        <div class="coupon-time" v-if="uiCoupinItem.days != undefined && uiCoupinItem.days!=0">有效期: {{uiCoupinItem.days}}天</div>

      </div>
    </div>
    <div v-if="!my">
      <div @click="$router.push('/index')" v-if=" stateText == 0" class="coupon-btn">{{state}}</div>
      <div v-if="stateText == 1" class="coupon-btn no-use">{{state}}</div>

      <div v-if="stateText == 2" class="coupon-btn no-use">{{state}}</div>
    </div>

    <div v-else>
      <div v-if="!uiCoupinItem.isFill || uiCoupinItem.isFill == 0 ">
        <div @click="receive" v-if="isShowBtnRight" class="coupon-btn">领取</div>
        <div v-else></div>
      </div>
      <div v-else class="no-color">
        <div v-if="isShowBtnRight" class="coupon-btn">已抢光</div>
        <div v-else></div>
      </div>

    </div>

    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "coupon",
  props: {
    isShowBtnRight: {
      type: Boolean,
      default: true
    },
    my: {
      type: Boolean,
      default: true
    },
    stateText: {
      type: Number,
      default: 0
    },
    coupinItem: {
      type: Object
    }
  },
  data() {
    return {
      id: "",
      state: "去使用",
      uiCoupinItem: {}
    };
  },
  created() {
    console.log(this.coupinItem);
    if (this.stateText == 1) {
      this.state = "已使用";
      //已使用
    } else if (this.stateText == 2) {
      this.state = "已过期";
      //已过期
    } else {
      this.state = "去使用";
    }
    this.uiCoupinItem = JSON.parse(JSON.stringify(this.coupinItem));
  },
  methods: {
    receive() {
      this.$emit("getReceive", this.coupinItem.id);
    }
  }
};
</script>

<style lang="scss" scoped>
.coupon-box {
  box-shadow: 0 5px 16px 0 rgba(0, 0, 0, 0.05);
  border-radius: 7px;
  margin-bottom: 1rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  background: url("../assets/index/coupon_bg.png") left center no-repeat;
  background-size: 100% 100%;
  background-color: #f5f5f5;
  height: 8.4rem;
  box-sizing: border-box;
  padding: 0 1.2rem;
  align-items: center;
  position: relative;
  .left-content {
    display: flex;
    align-items: center;
    width: 71%;
    .discount {
      font-family: PingFangSC-Semibold;
      font-size: 2.6rem;
      color: #fe5845;
      letter-spacing: 4px;
      line-height: 2.6rem;
      margin-right: 1rem;
      min-width: 39%;
      letter-spacing: -1px;
      display: flex;
      justify-content: center;
      align-items: center;
      // text-align: left;
      .rmb-icon {
        font-family: PingFangSC-Semibold;
        font-size: 1rem;
        color: #fe5845;
        letter-spacing: 4px;
        line-height: 2.6rem;
      }
    }
    .content {
      width: 61%;
      .coupon-name {
        font-family: PingFangSC-Semibold;
        font-size: 1.4rem;
        color: #424242;
        letter-spacing: 0;
        line-height: 1.4rem;
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        text-align: left;
      }
      .min {
        font-family: PingFangSC-Regular;
        font-size: 1.2rem;
        color: #424242;
        letter-spacing: 0;
        line-height: 1.2rem;
        margin: 0.6rem 0 1rem;
        text-align: left;
      }
      .coupon-time {
        opacity: 0.5;
        font-family: PingFangSC-Regular;
        font-size: 1rem;
        color: #424242;
        letter-spacing: 0;
        line-height: 1.4rem;
        text-align: left;
      }
    }
  }
  .left-content-eee {
    display: flex;
    align-items: center;
    width: 71%;
    .discount {
      font-family: PingFangSC-Semibold;
      font-size: 2.6rem;
      letter-spacing: 4px;
      line-height: 2.6rem;
      margin-right: 1rem;
      min-width: 39%;
      letter-spacing: -1px;
      display: flex;
      justify-content: center;
      align-items: center;
      opacity: 0.3;
      color: #424242;
      .rmb-icon {
        font-family: PingFangSC-Semibold;
        font-size: 1rem;
        opacity: 0.3;
        color: #424242;
        letter-spacing: 4px;
        line-height: 2.6rem;
      }
    }
    .content {
      width: 61%;
      .coupon-name {
        font-family: PingFangSC-Semibold;
        font-size: 1.4rem;
        color: #424242;
        opacity: 0.3;
        letter-spacing: 0;
        line-height: 1.4rem;
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        text-align: left;
      }
      .min {
        font-family: PingFangSC-Regular;
        font-size: 1.2rem;
        color: #424242;
        opacity: 0.3;
        letter-spacing: 0;
        line-height: 1.2rem;
        margin: 0.6rem 0 1rem;
        text-align: left;
      }
      .coupon-time {
        opacity: 0.5;
        opacity: 0.3;
        font-family: PingFangSC-Regular;
        font-size: 1rem;
        color: #424242;
        letter-spacing: 0;
        line-height: 1rem;
        text-align: left;
      }
    }
  }

  .coupon-btn {
    background-image: linear-gradient(90deg, #fde58b 0%, #f8d268 100%);
    border-radius: 8px;
    font-family: PingFangSC-Regular;
    font-size: 1.4rem;
    color: #78470c;
    letter-spacing: 0;
    line-height: 1.4rem;
    padding: 0.8rem 1rem;
  }
  .no-color {
    .coupon-btn {
      opacity: 0.2;
      background: #424242;
      border-radius: 8px;
      font-family: PingFangSC-Regular;
      font-size: 1.4rem;
      color: #ffffff;
      letter-spacing: 0;
      line-height: 1.4rem;
      padding: 0.8rem 1rem;
    }
  }
  .no-use {
    background-image: none;
    background: #e2e2e2;
    color: #5c5c5c;
    opacity: 0.5;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/coupon.vue